<template>
  <div class="tj">
    <Carousel :pics="homePics" :homeProp="true" :perPageCount="1" :fill="false" :fast="4000" />
    <div class="w-80-ns w-100 center lh-copy mv3">
      <div class="mv2-ns mt4-ns mt3 mb2 f1-ns center f3 tc ttu w-100 cf b1 tracked"><div class="w-33 fl">Unite</div><div class="w-33 pl3 fl">Build</div><div class="w-33 fr">Live</div></div>
      <hr class="w-80-ns w-90">
      <div class="tc mt3 w-100 gbounce mb4" :class="{ hide: position > 100 ? true : false }"><img class="arrow" src="@/assets/down.png" /></div>
      <div class="ph2 tc mt2">
        <div class="f2-ns f3 mb4">NYC’s commercial general contracting, luxury residential, and construction management firm.</div>
        <div class="mt5 f3 tc w-100 title-section">Who We Are</div>
        <!-- <div class="center f4">This paragraph serves the purpose to tell the user about United Builders Group and what they do. If a user clicks the button below, the user will be brought to the about page. That page serves to tell the user about United Builders Group more in-depth than this paragraph since this is the home page and the about page is supposed to tell the user <i>about</i> the company.</div> -->
        <div class="w-100 tc center"><router-link class="dim link button black pa3 f3-ns f4 mt4" to="/about" tag="button">About Us</router-link></div>
      </div>

      <div class="mt5-ns mt4 cover1">
      </div>

      <div class="ph2 tc mt5-ns mt4">
        <div class="mt5 f3 tc w-100 title-section">What We Do</div>
        <!-- <div class="center f4">This paragraph serves the purpose to tell the user about the past projects that United Builders Group has completed. If a user clicks the button below, the user will be brought to the portfolio page. That page serves to tell the user about the completed projects built by United Builders Group, including photos and a description about the projects. </div> -->
        <div class="w-100 tc center"><router-link class="dim link button black pa3 f3-ns f4 mt4" to="/portfolio" tag="button">Portfolio</router-link></div>
      </div>

      <div class="mt5-ns mt4 cover2">
      </div>

      <div class="ph2 tc mt5-ns mt4">
        <div class="mt5 f3 tc w-100 title-section">You Dream It, We Build It</div>
        <!-- <div class="center f4">This paragraph serves the purpose to tell the user about United Builders Group's office hours, their address, and contact information such as a work email and telephone number to allow the user to communicate United Builders Group. If the button below is clicked, the user will be brought to the contact page, giving the user more opportunities to get in touch with United Builders Group.</div> -->
        <div class="w-100 tc center"><router-link class="dim link button black pa3 f3-ns f4 mt4" to="/contact" tag="button">Let's Chat!</router-link></div>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from '@/components/Carousel'
import desk from '@/assets/30-Broad-37th-Floor/02.jpg'
import broad from '@/assets/30-Broad-Woods-Bagot/02.jpg'
import ave from '@/assets/641-Avenue-of-the-Americas/05.jpg'
export default {
  name: 'Home',
  data() {
    return {
      images: [
        "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80",
        "https://images.unsplash.com/photo-1489515229412-1f3a8f08dc34?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80",
        "https://images.unsplash.com/photo-1495036019936-220b29b930ea?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80",
        "https://images.unsplash.com/photo-1429497419816-9ca5cfb4571a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1051&q=80",
        "https://images.unsplash.com/photo-1516880711640-ef7db81be3e1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80",
        "https://images.unsplash.com/photo-1444419988131-046ed4e5ffd6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80"
      ],
      current_img: 0,
      position: null,
      homePics: [
        desk, broad, ave,
      ]
    };
  },
  methods: {
    handleScroll (e) {
      this.position = window.scrollY
    },
    next: function() {
      this.current_img += 1;
    },
    prev: function() {
      this.current_img -= 1;
      if (this.current_img < 0) {
        this.current_img = (this.images.length - 1);
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);

  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  components: { Carousel }
};
</script>

<style scoped>
.hide {
  display: none;
  transition: 2s;
}
.arrow {
  max-width: 20px;
}
@keyframes gbounce { 
  0% { transform: translateY(0); }
  30% { transform: translateY(-5px); }
  50% { transform: translateY(0); }
  100% { transform: translateY(0); }
}

.f25 {
  font-size: 1.8rem;
}
.gbounce {
  animation: gbounce 2s;
  animation-timing-function: ease;
  animation-iteration-count: infinite;
}
.b1 {
  font-weight: 500;
}
.button {
  background: transparent;
  /* border-top: none;
  border-left: none;
  border-right: none; */
  border: .5px solid black;
  color: black;
  cursor: pointer;
  text-align: center;
  font-weight: 500;
}
.button:hover {
  border-top: .5px solid black;
  border-left: .5px solid black;
  border-right: .5px solid black;
  color: black;
  transition: .5 ease-in
}
.title-section:before,
.title-section:after {
  content: "";
  margin: 0px 5px 0px 5px;
  border-top: 2px solid #000;
  width: 10%;
  padding-bottom: 4px;
  display: inline-block;
}
.big-section:before,
.big-section:after {
  content: "";
  margin: 0px -5px 0px -10px;
  border-top: 1px solid #000;
  width: 4%;
  padding-bottom: 10px;
  display: inline-block;
}
.cover1 {
  background: url('https://images.unsplash.com/photo-1537726227291-6163e542febc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2284&q=80') no-repeat;
  background-size: cover;
  height: 64vh;
}

.cover2 {
  background: url('https://images.unsplash.com/photo-1448630360428-65456885c650?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1347&q=80') no-repeat;
  background-size: cover;
  height: 64vh;
}

@media only screen 
and (min-device-width : 375px) 
and (max-device-width : 812px)
and (-webkit-device-pixel-ratio : 3) { 
  .cover1 {
    background-position: 41% 0%;
    height: 70vh;
  }
    .cover2 {
    background-position: 41% 0%;
    height: 70vh;
    width: 100%;
  }
}
</style>